import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { VOID_FN } from '../../../utils';
import { FEEDBACK_LAYER } from '../../standard/theme/constants';

function Feedback({ children, visible, onClose = VOID_FN, delay = 3000, style = {} }) {
  const timerRef = useRef(null);
  const [vue, setVue] = useState(visible);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    timerRef.current = setTimeout(() => {
      setVue(false);
      onClose();
      timerRef.current = null;
    }, delay);

    return () => {
      setVue(false);
      onClose();
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  return vue && (
    <div role="alert" style={{ ...style, zIndex: FEEDBACK_LAYER }}>
      {children}
    </div>
  );
}

export default Feedback;
